import React, { useContext, useState } from 'react';
import { Button } from 'reactstrap';
import ArrowLeaveSVG from '../svg/ArrowLeaveSVG';
import { GetSiteHosts, HasSiteWithAmbiguousHost } from 'util/AppStateUtils';
import { HasEditContext } from './withEditContext';
import ViewLiveModal from '../ViewLiveModal';
import EditContext from './EditContext';
import RocTitle from '../RocTitle';
import { IsAbsoluteUrl } from './fields/formatters';

export type EditViewLiveProps = HasEditContext;

/**
 * Displays a button that opens a new window and redirects the user to the live record fro the current
 * item being edited. Only displays while editing, and will display the value that was loaded from the DB,
 * not the current value from the text box (which may differ and take you to a 404).
 */
function EditViewLive() {
	const [isOpen, setIsOpen] = useState(false);
	const { values, entityDefinition } = useContext(EditContext);
	const url = values && values.url;

	// it's possible that url could be optional in some cases, outside of ISeo
	if (!url || !url.trim()) {
		return null;
	}

	const sites = GetSiteHosts(values.scope ? values.scope.value : null);

	if (sites.length === 0) {
		return null;
	}

	/**
	 * Handles the click event for the view live button.
	 * If the URL is absolute, it will open the URL in a new tab.
	 * If there's only one site, it will open the URL with the site's host.
	 * If there are multiple sites, it will open a modal to select the site.
	 */
	const onClick = () => {
		if (IsAbsoluteUrl(url)) {
			window.open(url, '_blank');
		} else if (HasSiteWithAmbiguousHost(sites)) {
			setIsOpen(true);
		} else {
			window.open(`${sites[0].hosts![0]}${url}`, '_blank');
		}
	};

	return (
		<>
			<RocTitle label="View record">
				<Button
					outline
					color="primary"
					disabled={entityDefinition.disableView(values)}
					className="btn btn-medium"
					data-testid="view-record-btn"
					onClick={onClick}
					size="sm"
				>
					<div>
						<ArrowLeaveSVG class="btn-icon-text-container__large-icon" />

						<span className="visually-hidden">View Live - Opens in a new window</span>
					</div>
				</Button>
			</RocTitle>
			<ViewLiveModal
				entityDefinition={entityDefinition}
				record={values}
				sites={sites}
				isOpen={isOpen}
				setModal={setIsOpen}
				testId={`edit-view-live`}
			/>
		</>
	);
}

export default EditViewLive;
